<template>
  <div
    class="home-recent-views-item"
    @click="homeClick(`Recently Viewed Item: ${fullName}`)"
  >
    <router-link
      :to="{ name, params, query }"
      class="d-flex flex-column align-start justify-start pa-4"
      :class="{ 'is-first': index === 0 }"
    >
      <h5 class="name">
        {{ formattedName }}<span
          v-if="meta.parentTitle"
          class="parent-title"
        > - {{ meta.parentTitle }}</span>
      </h5>
      <span class="time">{{ formattedTime }}</span>
    </router-link>
  </div>
</template>

<script>
import { startCase } from 'lodash-es';
import { formatDistanceToNow } from 'date-fns';
import { mapActions } from 'pinia';
import { useTracking } from '@/stores/tracking/tracking';

export default {
  name: 'HomeRecentViewsItem',
  props: {
    timestamp: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
    meta: {
      type: Object,
      default() {
        return {};
      },
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
    query: {
      type: Object,
      default() {
        return {};
      },
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    formattedName() {
      const title = this.meta?.title || startCase(this.name);

      return title;
    },
    formattedTime() {
      return `${formatDistanceToNow(new Date(this.timestamp))} ago`;
    },
    fullName() {
      return `${this.formattedName} ${this.meta?.parentTitle ? `- ${this.meta.parentTitle}` : ''}`;
    },
  },
  methods: {
    ...mapActions(useTracking, ['homeClick']),
  },
};
</script>

<style lang="less" scoped>
.home-recent-views-item {
  margin-top: 4px;
  width: 100%;
  background: fade(@grey-400, 5%);

  a {
    width: 100%;
  }

  &:hover {
    background: fade(@grey-400, 20%);
  }

  &.is-first {
    margin-top: 2px;
  }
}

.name {
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  color: @text-darkest;
  text-align: left;
}

.parent-title {
  font-size: 16px;
  font-weight: normal;
  color: @text-darkest;
}

.time {
  font-size: 12px;
  font-weight: 400;
  color: @text-light;
}
</style>
